
import StylesMixin from '@/ui-kit/mixins/styles';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Icon from '@/ui-kit/components/icon';
import Typography from '@/ui-kit/components/typography';

export default {
  name: 'ListingPropertyCharacteristics',
  components: {
    Icon,
    Typography,
  },
  mixins: [StylesMixin],
  props: {
    title: {
      default: '',
      type: String,
    },
    characteristics: {
      default: () => ([]),
      type: Array,
    },
    listClassName: {
      default: '',
      type: String,
    },
    descriptionClassName: {
      default: '',
      type: String,
    },
    columnsCount: {
      default: 1,
      type: Number,
    },
    colorScheme: {
      default: StyleColorSchemeType.White,
      type: String,
    },
  },
  data() {
    return {
      TypographyType,
    };
  },
  computed: {
    containerClassNames() {
      return new this.StyleClassNamesBuilder(this.rootClassName)
        .addConditionClassNames(Object.values(this.StyleColorSchemeType), this.colorScheme)
        .build();
    },
    listClassNames() {
      return new this.StyleClassNamesBuilder(`${this.rootClassName}__list`)
        .addClassName(this.listClassName)
        .build();
    },
    descriptionClassNames() {
      return new this.StyleClassNamesBuilder(`${this.rootClassName}__list-item-description`)
        .addClassName(this.descriptionClassName)
        .build();
    },
  },
  methods: {
    getListItemClassNames(index) {
      return new this.StyleClassNamesBuilder(`${this.rootClassName}__list-item`)
        .addConditionClassName('first-line', index < this.columnsCount)
        .build();
    },
  },
};
